import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Ai thấy trang "Thông báo của tôi": cùng quyền với chuông (`notification.read`)
 * — trang chỉ đọc / đánh dấu hộp thư của CHÍNH người mở. Vai không có quyền
 * (Chỉ xem, vai đã khoá) không thấy mục, khỏi bấm vào rồi ăn 403.
 */
export function canReadMyNotifications(): boolean {
  return hasPermission(ACTION.NotificationRead);
}
